import React, { useEffect, useState } from 'react';
import { FaLongArrowAltLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ApplicationService from '../services/axios.service';
import Spinner from './spinner';

const SalesBulkUploadHistory = () => {
  const [history, setHistory] = useState([]); // State to hold the history data
  const [loading, setLoading] = useState(true); // Loading state
  const [currentPage, setCurrentPage] = useState(1); // Current page state
  const recordsPerPage = 10; // Number of records to show per page
  const navigate = useNavigate();
  const service = new ApplicationService(); // Creating an instance of ApplicationService

  const fetchHistory = async () => {
    try {
      const response = await service.getSalesLapHistory({}); // Pass the necessary payload if required
      if (response.status === 200) {
        setHistory(response.data); // Set the response data to history
      } else {
        console.error("Error fetching bulk upload history:", response.message);
      }
    } catch (error) {
      console.error("Error fetching bulk upload history:", error);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };

  // useEffect to fetch the data when the component mounts
  useEffect(() => {
    fetchHistory();
  }, []);

  // Pagination logic
  const totalPages = Math.ceil(history.length / recordsPerPage); // Calculate total pages

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Get current records to display
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentHistory = history.slice(indexOfFirstRecord, indexOfLastRecord);

  return (
    <div className="bg-white p-4">
      <button className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 cursor-pointer" onClick={() => navigate("/upload-saleslap-excel")}>
        <span className='text-white flex flex-row'>  <FaLongArrowAltLeft /> &nbsp; Back</span>
      </button>
      <div className="container mx-auto">
        <div className="flex justify-between items-center border-b p-4">
          <h1 className="text-xl font-semibold">Bulk Upload History</h1>
          {/* <button className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600">
            <i className="fas fa-sync-alt mr-2"></i> <span className='text-white cursor-pointer'>Refresh</span>
          </button> */}
        </div>

        <div className="overflow-x-auto h-[80vh]">
          <table className="min-w-full text-sm text-gray-600 ">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 text-left">File Name</th>
                <th className="px-4 py-2 text-left">Created at</th>
                <th className="px-4 py-2 text-left">Status</th>
                <th className="px-4 py-2 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    <Spinner /> {/* Show spinner while loading */}
                  </td>
                </tr>
              ) : (
                currentHistory.map((entry, index) => (
                  <tr
                    key={index}
                    className={`border-b ${entry.status === 'errored' ? 'bg-red-50' : 'bg-green-50'}`}
                  >
                    <td className="px-4 py-2">{entry.filename}</td>
                    <td className="px-4 py-2">{entry.created_at}</td>
                    <td className="px-4 py-2">{entry.status}</td>
                    <td className="px-4 py-2 flex gap-3">
                      <button
                        onClick={() => navigate(`/sales-bulk-upload-error/${entry.id}`)}
                        className={`${entry.status === 'errored' ? 'bg-orange-500' : 'bg-green-500'} text-white py-1 px-3 rounded-md hover:bg-opacity-80 mr-2 cursor-pointer`}
                      >
                        <span className="text-white">View Details</span>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-4">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-300 text-white rounded-md cursor-pointer mr-2 disabled:opacity-50"
          >
            &lt; Previous
          </button>
          <span className="px-4 py-2 text-gray-700">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-300 text-white rounded-md cursor-pointer ml-2 disabled:opacity-50"
          >
            Next &gt;
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalesBulkUploadHistory;
